import { COMMON_TAGS } from '@atlassian/search-common/constants';
import { getSentryClient } from '@atlassian/search-common/sentry';

/**
 * Logs an exception to Sentry.
 *
 * Mirrors the search-page `logException`
 * (`search-page/src/controllers/error-boundary/log-exception.ts`), minus the
 * `userId` / `primaryProduct` scope tags — `useRovoConfig` is internalised and
 * intentionally does not depend on the search-page store, so those values are
 * not available here.
 *
 * Used by `useRovoConfig` so that config-fetch failures in the canonical
 * (FG-on) path continue to be reported to Sentry, matching the legacy
 * search-page config-fetch behaviour.
 */
export const logException = async (error: unknown): Promise<void> => {
	try {
		const SentryClient = await getSentryClient();

		if (!SentryClient) {
			return;
		}

		SentryClient.withScope((scope) => {
			for (const [key, value] of Object.entries(COMMON_TAGS)) {
				scope.setTag(key, value);
			}
			SentryClient.captureException(error, scope);
		});
	} catch (sentryError) {
		// When there was an error with Sentry, just output to console.
		// eslint-disable-next-line no-console
		console.error(sentryError);
	}
};
